export default __webpack_public_path__ + "static/testimonial-bg-mobile-098774ff3ee4907cacb71e8473c69668.png";